import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiRequestModel } from '../../../../../../src/app/ncs/models/api_request_model';



@Component({
  selector: 'smartphone-menu',
  templateUrl: './smartphonemenu.component.html',
  styleUrls: ['./smartphonemenu.component.scss']
  //styleUrls: ['./rncloudstartup.component.scss']
})

export class SmartPhoneMenuComponent implements OnInit {


  public ApiReqData: ApiRequestModel;
  constructor(
    private router: Router, private route: ActivatedRoute, private loginservice: LoginService,) { }
  ngOnInit() {



  }






}
